import React from "react";
import { I18nProvider } from "@/i18n/I18nProvider";
import SEOHead from "@/components/SEOHead";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import HowItWorks from "@/components/landing/HowItWorks";
import Features from "@/components/landing/Features";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import CTAFinal from "@/components/landing/CTAFinal";
import Footer from "@/components/landing/Footer";
import Ticker from "@/components/landing/Ticker";

function Landing() {
  return (
    <main className="min-h-screen bg-bg text-ink" data-testid="landing-root">
      <SEOHead />
      <Header />
      <Hero />
      <Problem />
      <Ticker />
      <HowItWorks />
      <Features />
      <BeforeAfter />
      <Pricing />
      <Testimonials />
      <FAQ />
      <CTAFinal />
      <Footer />
    </main>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <Landing />
    </I18nProvider>
  );
}
